import React from 'react';
import { Dialog } from '@mui/material';
import { useTheme, useMediaQuery } from '@ublend-npm/aulaui-core';
import PostDetail from './PostDetail';

export interface PostDetailPopupProps {
  item: any;
  open: boolean;
  onClose: () => void;
}

const PostDetailPopup: React.FC<PostDetailPopupProps> = ({
  open,
  onClose,
  item,
}) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      fullScreen={isSmallScreen}
      aria-labelledby="post-detail-title"
      PaperProps={{
        sx: {
          bgcolor: theme.palette.background.paper,
          color: theme.palette.text.primary,
          borderRadius: isSmallScreen ? 0 : 2,
          maxWidth: '648px',
          maxHeight: isSmallScreen ? '100vh' : '85vh',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        },
      }}
    >
      <PostDetail item={item} onClose={onClose} />
    </Dialog>
  );
};

export default PostDetailPopup;
